import React from 'react';
import moment from 'moment';
import { DateField } from 'components/form/rhf';
import { Box, Stack, Tooltip } from '@mui/material';
import { Control, useWatch } from 'react-hook-form';
import { WarningAmberOutlined } from '@mui/icons-material';

import { DealBuilderFormValues } from '../../../../types';

interface Props {
  rowIndex: number;
  control: Control<DealBuilderFormValues>;
}

export const PayoffGoodThroughDateCell = ({ control, rowIndex }: Props) => {
  const [payoffGoodThroughDate] = useWatch({
    control,
    name: [`pricing.tradeIn.${rowIndex}.payoffGoodThroughDate`],
  });

  // Payoff quotes are only valid through the lender's stated date
  const isExpired = !!payoffGoodThroughDate && moment(payoffGoodThroughDate).isBefore(moment(), 'day');

  return (
    <Stack direction="row" gap="0.5rem" alignItems="center">
      <Box flex={1}>
        <DateField
          control={control}
          label="Payoff Good-Through Date"
          name={`pricing.tradeIn.${rowIndex}.payoffGoodThroughDate`}
          slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
        />
      </Box>

      {isExpired && (
        <Tooltip arrow title="Payoff quote has expired">
          <WarningAmberOutlined color="warning" fontSize="small" />
        </Tooltip>
      )}
    </Stack>
  );
};
